
import "./styles/PoleStatus.css";

const UserStatus = ({ isOnline }) => {
  const status = isOnline ? "online" : "offline";
  return (
    <div className={`user-status ${status}`}>
      <p>{isOnline ? "● เปิดใช้งาน" : "● ปิดการใช้งาน"}</p>
    </div>
  );
};

export default UserStatus;
